import React, {useState} from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, LabelList, Cell, ResponsiveContainer } from 'recharts';

// Custom tooltip to show the symbolName
const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: 'transparent',          
          textAlign: 'center',
          color:`${payload[0].payload.isOpen ? payload[0].payload.roi >= 0 ? '#6ac46a' : '#ec8282' : '#ff4b00'}`,
          textShadow:'-1px -1px 0 #131722, 1px -1px 0 #131722, -1px 1px 0 #131722, 1px 1px 0 #131722',          
        }}
      >
        <span>{`${payload[0].payload.symbol.replace('-USD','')} ${payload[0].payload.isOpen?'':'(Closed)'}`}</span><br/>
        <span>{payload[0].payload.roi}%</span>
      </div>
    );
  }
  return null;
};

// Custom tick renderer for the X-Axis
const CustomXAxisTick = ({ x, y, payload }) => (
  <foreignObject x={x - 10} y={y} width="20" height="20">
    <img
      src={payload.value} // Image URL
      alt=""
      style={{
        width: '20px',
        height: '20px',
        objectFit: 'contain',
      }}
    />
  </foreignObject>
);

const ChartROIBar = (data) => {
  
  const [hoveredBar, setHoveredBar] = useState(null);
  // Transform the data to use absolute ROI values for the chart
  const transformedData = data.data.map((item) => ({
    ...item,
    absROI: Math.abs(item.roi), // Always use the absolute value for the chart
  }));

  return (
    <div
      style={{
        width: '335px',
        height: '160px',
        overflow: 'hidden',
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={transformedData} margin={{ top: 20, right: 10, left: 10, bottom: 30 }}>
          {/* Y-Axis */}
          <YAxis hide />
          {/* X-Axis */}
          <XAxis
            dataKey="symbolIcon"
            tick={CustomXAxisTick} // Pass the custom tick function directly
            tickSize={10}
            interval={0}
            tickLine={false}
          />
          {/* Tooltip */}
          <Tooltip cursor={{fill: 'transparent'}} content={<CustomTooltip />} />        
          {/* Bars */}
          <Bar
            dataKey="absROI"
            radius={[5, 5, 0, 0]} // Rounded corners on top
            barSize={20}            
            onMouseEnter={(data, index) => setHoveredBar(index)}
            onMouseLeave={() => setHoveredBar(null)}
          >
            {data.data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.isOpen ? entry.roi >= 0 ? '#6ac46a' : '#ec8282' : '#ff4b00'} // Green for positive, red for negative
                fillOpacity={hoveredBar === index ? 1 : 0.8}
                style={{
                  transition: 'none', // Prevents hover changes
                }}
              />
            ))}
            {/* ROI Value Labels */}
            <LabelList
              dataKey="roi"
              position="top"
              formatter={(value) => `${value}%`}
              style={{ fill: data.data.length > 10 ? 'transparent' : (value) => value > 0 ? '#6ac46a' : '#ec8282', fontSize: 12, fontWeight: 'bold' }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ChartROIBar;